import { useState, useEffect } from 'react';
import { StyledToTopButton } from './ToTopButton.style';
import ToTop from '/assets/image/to_top_button.svg';

export const ToTopButton = () => {
  const [isShown, setIsShown] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, offsetHeight } = document.documentElement;
      if (scrollTop > offsetHeight) {
        setIsShown(true);
      } else {
        setIsShown(false);
      }
    };
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <StyledToTopButton
      onClick={() =>
        document.documentElement.scrollTo({
          behavior: 'smooth',
          top: 0,
        })
      }
      show={isShown}
    >
      <img src={ToTop} alt="to top button" style={{ height: '100%' }} />
    </StyledToTopButton>
  );
};
